import { useProfileContext } from "Auth/contexts";
import React from "react";

import { FormBuilder } from "shared/components";
import { API_ENDPOINTS } from "shared/constants";
import {
  IAPIError,
  IAPIState,
  IFormButtons,
  IFormFields,
  IFormFieldStyle,
} from "shared/types";

export interface UserFormProps {
  handleSubmit: (data: any) => void;
  buttons: IFormButtons;
  apiStatus?: IAPIState | null;
  apiError?: IAPIError | null;
  defaultValues?: Record<string, any>;
  submitMode?: "isDirty";
  error?: string | boolean;
}

interface UserEntityFormProps extends UserFormProps {
  fields: IFormFields;
  style?: IFormFieldStyle;
}

export const UserEntityForm: React.FC<UserEntityFormProps> = ({
  fields,
  error,
  apiError,
  apiStatus,
  submitMode,
  defaultValues,
  handleSubmit,
  buttons,
  style,
}) => {
  const { currentUser } = useProfileContext();

  const onSubmit = (data: any) => {
    if (!currentUser) return;

    handleSubmit({
      ...data,
      user: API_ENDPOINTS.USER(currentUser.id),
    });
  };

  return (
    <FormBuilder
      fields={fields}
      mode="onSubmit"
      submitMode={submitMode}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      apiErrorMessage={error}
      apiError={apiError}
      buttons={buttons}
      style={style}
      isSubmitting={apiStatus === IAPIState.pending}
    />
  );
};
